module.exports = __webpack_public_path__ + "static/media/pen-alt.502af5c2.svg";